"use strict";

var end = {};

module.exports.AbstractPersonResource = {
  personIdent: {
    personIdentTyp: end
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/resource/abstractPerson.js
// module id = qVm1
// module chunks = 0